// eslint-disable-next-line
// @ts-nocheck
import { Formik } from 'formik';
import Page from '../../components/Page';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import {
  Box,
  Button,
  Card,
  Container,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import Scrollbar from '../../components/Scrollbar';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {
  useGetBlackoutDatesMutation,
  useSaveBlackoutDateMutation,
  useUpdateBlackoutDateMutation,
} from '../../store/api/blackoutDayApi';
import { getBlackoutDay, setBlackoutDay } from '../../store/state/blackoutDaySlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { format } from 'date-fns';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import SearchNotFound from '../../components/SearchNotFound';
import { getOfferTotalRecord } from '../../store/state/offerSlice';
import toast from 'react-hot-toast';
import * as Yup from 'yup';
import { useFindParkingSpaceLocationByIdMutation } from '../../store/api/parkingsApi';

const blackoutDateSchema = Yup.object().shape({
  description: Yup.string().required('This field is required'),
  date: Yup.string().required('This field is required').typeError('Please enter date and time.'),
});

const TABLE_HEAD = [
  { id: ' date', label: 'Date', alignRight: false },
  { id: 'description', label: 'Event', alignRight: false },
];

export default function BlackoutDay() {
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [activeModel, setActiveModel] = useState(false);
  const [filedValue, setFieldValue] = useState();
  const token = JSON.parse(localStorage.getItem('login') || '{}').token;
  const [blackoutData, setBlackoutData] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [saveBlackoutDate, saveBlackoutDateResponse] = useSaveBlackoutDateMutation();
  const [getBlackoutDates, getBlackoutDatesResponse] = useGetBlackoutDatesMutation();
  const [updateBlackoutDate, updateBlackoutDateResponse] = useUpdateBlackoutDateMutation();
  const offerTotalRecord = useAppSelector(getOfferTotalRecord);
  const [balckoutDayId, setBlackoutDayId] = useState<number>();
  const [balckoutDayDate, setBalckoutDayDate] = useState();
  const [balckoutDayDescription, setBalckoutDayDescription] = useState();
  const getBlackoutData = useAppSelector(getBlackoutDay);
  const [findParkingSpaceLocationById, findParkingSpaceLocationByIdResponse] =
    useFindParkingSpaceLocationByIdMutation();
  const [formValues, setFormValues] = useState({
    description: '',
    date: '',
  });
  const [date, setDate] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handelActiveModelClose = () => setActiveModel(false);
  const cancelDelete = () => {
    setOpen(false);
  };
  const cancelactiveModel = () => {
    setActiveModel(false);
  };
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    width: '500px',
    height: '450px',
  };

  const styleActiveModel = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };
  const handleAddBlackoutDay = (values: any, action: any) => {
    action.resetForm();
  };

  const saveBlackoutDay = (values: any, action) => {
    saveBlackoutDate({
      payload: {
        date: values.date,
        description: values.description,
        status: true,
      },
      token: token,
    });
    action.resetForm();
  };

  useEffect(
    (action) => {
      if (saveBlackoutDateResponse.isSuccess) {
        setOpen(false);
        getBlackoutDates({
          token: token,
          payload: {
            page: page,
            orderBy: order,
            offset: rowsPerPage,
          },
        });
        toast.success('Blackout date added successfully.');
      }
    },
    [saveBlackoutDateResponse.isSuccess]
  );

  useEffect(() => {
    getBlackoutDates({
      token: token,
      payload: {
        page: page,
        orderBy: order,
        offset: rowsPerPage,
      },
    });
  }, []);

  useEffect(() => {
    if (getBlackoutDatesResponse.isSuccess) {
      dispatch(setBlackoutDay(getBlackoutDatesResponse.data));
    }
  }, [getBlackoutDatesResponse.isSuccess]);

  useEffect(() => {
    if (getBlackoutData) {
      setBlackoutData(getBlackoutData);
    }
  }, [getBlackoutData]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    getBlackoutDates({
      token: token.token,
      payload: { offset: rowsPerPage, page: page, searchValue: event.target.value },
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getBlackoutDates({
      token: token.token,
      payload: { offset: rowsPerPage, page: newPage, orderBy: order },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getBlackoutDates({
      token: token.token,
      payload: { offset: event.target.value, page: 0, orderBy: order },
    });
  };

  const updateBlackoutDay = (id: any) => {
    updateBlackoutDate({
      token: token,
      payload: {
        id: balckoutDayId,
        date: balckoutDayDate,
        description: balckoutDayDescription,
        status: false,
      },
    });
  };

  useEffect(
    (action) => {
      if (updateBlackoutDateResponse.isSuccess) {
        setActiveModel(false);
        getBlackoutDates({
          token: token,
          payload: {
            page: page,
            orderBy: order,
            offset: rowsPerPage,
          },
        });
      }
    },
    [updateBlackoutDateResponse.isSuccess]
  );

  const filteredUsers = blackoutData;
  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Page title="Blackout Day">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            Blackout Day
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              handleOpen();
            }}
            size="large"
          >
            Add
          </Button>
        </Stack>
        <Card>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <BookingListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
            />
          </Stack>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={blackoutData.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const { id, name, date, description, status } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">
                            <Typography>{format(new Date(date), 'MM/dd/yyyy')}</Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography>{description}</Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Stack direction="row" alignItems="center">
                              <Switch
                                checked={status}
                                onClick={() => {
                                  setActiveModel(true);
                                  setBlackoutDayId(id);
                                  setBalckoutDayDate(date);
                                  setBalckoutDayDescription(description);
                                }}
                              />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={offerTotalRecord || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {open && (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '20px',
                }}
              >
                <h2
                  style={{
                    marginBottom: '10px',
                  }}
                >
                  Add Blackout Day
                </h2>
                <p
                  style={{
                    fontSize: '20px',
                  }}
                  onClick={cancelDelete}
                >
                  <HighlightOffIcon />
                </p>
              </div>

              <Formik
                enableReinitialize={true}
                initialValues={formValues}
                onSubmit={saveBlackoutDay}
                validationSchema={blackoutDateSchema}
              >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue, handleSubmit }) => (
                  <Container
                    sx={{
                      paddingTop: '4px',
                      paddingBottom: '4px',
                    }}
                  >
                    <Box marginBottom={'10px'}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Enter date"
                          value={values.date}
                          onChange={(event: any) => {
                            setFieldValue('date', event);
                          }}
                          renderInput={(params) => (
                            <TextField
                              id="date"
                              name="date"
                              style={{
                                width: '100%',
                                borderColor: 'blue',
                              }}
                              onBlur={handleBlur}
                              onChange={(event: any) => {
                                setFieldValue('date', event.target.value);
                              }}
                              {...params}
                              error={Boolean(touched.date && errors.date)}
                              helperText={touched.date && errors.date}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Box>
                    <Box alignItems={'center'}>
                      <Box width="100%">
                        <Stack direction="column" alignItems="self-start">
                          <TextField
                            sx={{ width: '100%', marginTop: '20px' }}
                            placeholder="Event description"
                            variant="outlined"
                            id={'outlined-multiline-static'}
                            name={'description'}
                            value={values.description}
                            multiline
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.description && errors.description)}
                            helperText={touched.description && errors.description}
                          />
                        </Stack>
                      </Box>
                    </Box>
                    <Box marginTop={'25px'}>
                      <InputLabel id="serviceProviderId">Service Provider</InputLabel>
                      <Select
                        name="serviceProviderId"
                        id="serviceProviderId"
                        key={values.serviceProviderId}
                        value={values.serviceProviderId}
                        onChange={handleChange}
                        fullWidth
                        displayEmpty
                        defaultValue={'0'}
                      >
                        <MenuItem disabled value="0">
                          Select Option
                        </MenuItem>
                      </Select>
                    </Box>
                    <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                      <Button
                        onClick={() => {
                          handleSubmit();
                        }}
                        variant="contained"
                        sx={{ padding: '8px', width: '100%', marginTop: '30px' }}
                      >
                        Save
                      </Button>
                    </Stack>
                  </Container>
                )}
              </Formik>
            </Box>
          </Modal>
        )}
      </Container>
      {activeModel && (
        <Modal
          open={activeModel}
          onClose={handelActiveModelClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleActiveModel}>
            <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
              Are you sure?
            </Typography>
            <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
              <Button variant="contained" onClick={cancelactiveModel} sx={{ margin: '10px' }} color="error">
                No
              </Button>
              <Button variant="contained" onClick={updateBlackoutDay} sx={{ margin: '10px' }}>
                Yes
              </Button>
            </Stack>
          </Box>
        </Modal>
      )}
    </Page>
  );
}
